import React, { Suspense, useEffect, useState } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import { useSelector } from "react-redux";
import CustomTabs from "../CustomTabs/CustomTabs";

import { useSearchParams } from "react-router-dom";

function MoreComps({ accountContactList,handleTabChange }) {
    const { account_contacts_loading } = useSelector(state => state.accountContactsReducer);
    const { dynamicTabsData } = useSelector(state => state.dynamicTabsReducer);
    const [tabsToRender,setTabsToRender]=useState([])
    const [searchParams, setSearchParams] = useSearchParams();
      useEffect(() => {
        if (searchParams.get("subTab") == "financial") {
          setSearchParams({
            tab: "more",
            subTab: "financial",
          });
        } else {
          setSearchParams({
            tab: "more",
             // subTab: "business",
             subTab: "documents",
          });
        }
      }, []);

  useEffect(() => {
    
    const tabData = [];


      dynamicTabsData.forEach(item=>tabData.push({label:item?.
        tab_name , comp:<CustomTabs content={item?.content}/>
        }))
        setTabsToRender(tabData)

  }, [dynamicTabsData])
  

  return <Suspense fallback={<div>Loading...</div>}><GenericTabs tabs={tabsToRender} handleTabChange={handleTabChange} /></Suspense>;
}

export default MoreComps;
